@let _organisation = organisation()!;
@let _cardProductTexts = cardProductTexts()!;
@if (_organisation && _cardProductTexts) {
  <ez-main-layout [theme]="Themes.NONE" [showWithdrawalLink]="true">
    <ez-banner>
      <ez-stepper></ez-stepper>
      <span ngProjectAs="title">Herzlichen Glückwunsch!</span>
    </ez-banner>

    <p class="center">
      <b>
        Sie haben die {{ _cardProductTexts.completionName }} Ihrer {{ _organisation.shortName }} in Zusammenarbeit mit
        der DZ&nbsp;BANK als Herausgeber der Kreditkarte erfolgreich beantragt.
      </b>
    </p>

    <p class="center">
      Die zusammenfassende Bestätigung erhalten Sie von {{ _organisation.emailSenderAddress }} per E-Mail. Prüfen Sie
      gegebenenfalls auch Ihren Spam-Ordner.
    </p>
  </ez-main-layout>
}
